import React from 'react';
import { SearchFooter } from '@atlassian/search-dialog';

import { AtlassianHomeSearchLink } from './atlassian-home-search-link';
import {
	ReturnIconWithModifier,
	AdvancedSearchFooter,
	type AdvancedSearchFooterProps,
} from './advanced-search-footer';

const ReturnIcon = () => <ReturnIconWithModifier />;

export const ExtensibleConfluenceTabFooter: ({
	orgId,
	cloudId,
	...props
}: AdvancedSearchFooterProps & {
	orgId?: string;
	cloudId?: string;
}) => React.JSX.Element = ({
	orgId,
	cloudId,
	...props
}: AdvancedSearchFooterProps & { orgId?: string; cloudId?: string }) => {
	return (
		<>
			<SearchFooter>
				<AdvancedSearchFooter {...props} returnKeyIconComponent={ReturnIcon} />
			</SearchFooter>
			{orgId && cloudId && (
				<SearchFooter>
					<AtlassianHomeSearchLink orgId={orgId} cloudId={cloudId} showModifierIcon />
				</SearchFooter>
			)}
		</>
	);
};
